import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './main.routes';

export class MainController {
  user = {
    name: '',
    email: '',
    password: ''
  };
  errors = {
    login: undefined
  };
  submitted = false;

  constructor(Auth, $state, SettingsService, PermPermissionStore, Idle, $analytics) {
    'ngInject';
    this.$state = $state;
    this.Auth = Auth;
    this.Idle = Idle;
    this.PermPermissionStore = PermPermissionStore;
    this.$analytics = $analytics;

    this.name = "";
  }

  login(form) {
    this.submitted = true;

    if(form.$valid) {
      this.Auth.login({
        email: this.user.email.toLowerCase(),
        password: this.user.password
      })
        .then(() => {

          if (this.$analytics) {
            this.$analytics.setUsername(this.user.email);
          }

          // Start the Lockscreen timer
          this.Idle.watch();

        /*
        let user = this.Auth.getCurrentUserSync();

        this.PermPermissionStore.clearStore();
        this.PermPermissionStore
          .definePermission('community.create', function (RolesConfig) {
            'ngInject';
            return RolesConfig.can(user,"community.create");
          });

         */

          // Logged in, redirect to home
          this.$state.go('home');
        })
        .catch(err => {
          this.errors.login = err.message;
        });
    }
  }
}

export default angular.module('conduu.main', [uiRouter])
  .config(routing)
  .component('main', {
    template: require('./main.html'),
    controller: MainController,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/main/main.component.js